/*eslint-disable */
import React, { useState, useEffect } from 'react'
import { Button, Checkbox, Dropdown, Modal, Radio, Divider, Header, } from 'semantic-ui-react'
import { withFormik, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Form as FormUi } from "semantic-ui-react";
import { MyNormalInput } from '../dynamicComponent/myInputs';
import { AllRegex } from "../../utils/validation";
import CreateAxios from '../axiosComponent/create';
import {REQUIRED_FIELDS, INVALID_FIELDS, ERROR_MESSAGES} from '../../utils/validationConstant';
import cogoToast from "cogo-toast";
import {LR_SERIES} from './branchConstants'

const CreateLrSeries = ({ isSubmitting, handleSubmit, values, setFieldValue, touched, errors, t, OpenModal, CloseModal, resetForm}) => {

    const [lrSampleValue, setLrSampleValue] = useState("")

    useEffect(()=>{
        setLrSample()
    },[values])

    const setLrSample = ()=>{
        let { lrFirst, lrLast, dateFormatYear,dateFormatMonth , specialCharacter, branchCode, seriesPrefix } = values;
        if(!lrFirst){
            lrFirst=1
        }
        let dateFormat = ""
        if(dateFormatYear){
            dateFormat+="Y"
        }
        if(dateFormatMonth){
            dateFormat+="M"
        }
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;

        dateFormat = dateFormat ? dateFormat.replace('Y', year).replace('M', month) : '';
            let lrNumber = (seriesPrefix ? seriesPrefix + specialCharacter : '') + 
                            (dateFormat ? dateFormat + specialCharacter : '') + 
                            lrFirst.toString().padStart(7, '0');

        setLrSampleValue(lrNumber)
    }

    const SeriesTypes = [{
        text:"Yearly",
        value:"Yearly",
        key:1
    },{
        text:"Monthly",
        value:"Monthly",
        key:2
    }]

    return (
        <Modal
            onClose={()=>{
                resetForm()
                CloseModal()
            }}
            open={OpenModal}
            size="medium"
            className="p-overflow-initial"
        >
            <Modal.Header style={{ fontSize: "14px" }}>{LR_SERIES.titles.add ||"Create LR Series"}</Modal.Header>
            <Modal.Content scrolling>
                <div className="ui form small">
                    <FormUi.Group>
                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.prefix.title||"Series Prefix"}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="seriesPrefix" component={MyNormalInput} placeholder ={LR_SERIES.fields.prefix.placeholder||"Enter Series Prefix"} maxLength={5}/>
                        {touched.seriesPrefix && errors.seriesPrefix ? <small className="text-danger">{errors.seriesPrefix}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.date_format.title||"Date Format"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="2">
                        <div className='row'>
                        <div className='col'>
                        <label className="labelName">{LR_SERIES.fields.date_format.year||"Year"}</label>
                        </div>
                        <div className='col'>
                        <Checkbox
                                onChange={(e) =>
                                  setFieldValue(
                                    "dateFormatYear",
                                    e.target.checked ? true : false
                                  )
                                }
                                id="dateFormatYear"
                                type="checkbox"
                                className="form-check-input large"
                              />
                              </div>
                              </div>
                            </FormUi.Field>
                            <FormUi.Field width="2">
                            <div className='row'>
                            <div className='col'>
                            <label className="labelName">{LR_SERIES.fields.date_format.month||"Month"}</label>
                            </div>
                            <div className='col'>
                            <Checkbox
                                onChange={(e) =>
                                  setFieldValue(
                                    "dateFormatMonth",
                                    e.target.checked ? true : false
                                  )
                                }
                                id="dateFormatMonth"
                                type="checkbox"
                                className="form-check-input large"
                              />
                                        
                             {touched.dateFormat && errors.dateFormat ? <small className="text-danger">{errors.dateFormat}</small> : ''}
                             </div>
                             </div>
                        </FormUi.Field>
                    </FormUi.Group>


                    <FormUi.Group>
                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.special_charecter.title||"Special Charecter"}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="specialCharacter" component={MyNormalInput} placeholder ={LR_SERIES.fields.special_charecter.placeholder||"Enter Special charecter"} maxLength={1}/>
                        {touched.specialCharacter && errors.specialCharacter ? <small className="text-danger">{errors.specialCharacter}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />

                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.series_type.title||"Series Type"}</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                        <Dropdown
                            name="seriesType"
                            clearable
                            style={{ width: "100%", fontWeight: "normal" }}
                            selection
                            placeholder={LR_SERIES.fields.series_type.placeholder||"Select Series Type"}
                            options={SeriesTypes}
                            onChange={(name, data) => {
                              setFieldValue("seriesType", data.value);
                            }}
                          />
                        {touched.seriesType && errors.seriesType ? <small className="text-danger">{errors.seriesType}</small> : ''}
                        </FormUi.Field>
                        
                    </FormUi.Group>

                    <FormUi.Group>
                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.lr_start.title || "LR Starting From"}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="lrFirst" component={MyNormalInput} type="number" placeholder ={LR_SERIES.fields.lr_start.placeholder||"Enter LR Starting Number"}/>
                        {touched.lrFirst && errors.lrFirst ? <small className="text-danger">{errors.lrFirst}</small> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />

                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.lr_end.title ||"LR Ending In"}{" "}<b className="w3-text-red"> *</b></label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                            <Fieldmik name="lrLast" component={MyNormalInput} type="number" placeholder ={LR_SERIES.fields.lr_end.placeholder||"Enter LR Ending Number"}/>
                        {touched.lrLast && errors.lrLast ? <small className="text-danger">{errors.lrLast}</small> : ''}
                        </FormUi.Field>
                    </FormUi.Group>

                        <FormUi.Field width="3">
                            <label className="labelName">{LR_SERIES.fields.lr_sample.title||"LR Number Sample"}</label>
                        </FormUi.Field>
                    <FormUi.Group>    
                        <FormUi.Field width="7">
                            <Fieldmik name="lrSample" component={MyNormalInput} disabled value={lrSampleValue} placeholder ={LR_SERIES.fields.lr_sample.placeholder || "LR Number Sample"}/>
                        </FormUi.Field>
                        <FormUi.Field width="7"/>
                    </FormUi.Group>

                    <FormUi.Group>
                    <FormUi.Field>
                            <small className='form-text text-muted w3-text-red font-weight-bold'>{LR_SERIES.fields.note||"Note : Please refer LR Number Sample as an example , LR will be starting from this."}</small>
                    </FormUi.Field>
                    </FormUi.Group>
                </div>
            </Modal.Content>
            <Modal.Actions>
                <Button color='green' size="mini" type='button' onClick={()=>{
                    resetForm()
                    CloseModal()
                }}>
                    {LR_SERIES.buttons.cancel||"Cancel"}
                </Button>
                <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
                    {LR_SERIES.buttons.submit||"Submit"}
                </Button>
            </Modal.Actions>
        </Modal>
    )
}

const FormikCreateLrSeries = withFormik({
    
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        return {
            seriesPrefix: "",
            dateFormatYear:false,
            dateFormatMonth:false,
            specialCharacter:"",
            seriesType:"",
            lrFirst:"",
            lrLast:"",
            branchCode:props.branchCode || "",
            branchId: props.branchId || ""
        }
    },
    validationSchema: yup.object({
        lrFirst: yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).min(1,ERROR_MESSAGES.MIN_VALUE(1)).max(9999999,ERROR_MESSAGES.MAX_LENGTH(7)),
        lrLast: yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).min(1,ERROR_MESSAGES.MIN_VALUE(1)).max(9999999,ERROR_MESSAGES.MAX_LENGTH(7)),
        specialCharacter : yup.string().matches(AllRegex.SpecialCharecter, INVALID_FIELDS.INVALID_SPECIAL_CHARECTER).required(REQUIRED_FIELDS.FIELD_IS_REQUIRED),
        seriesPrefix: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED)
    }),
    async handleSubmit(values, { props }) {
       let dateFormat=""
       if(values.dateFormatYear){
        dateFormat+="Y"
       }
       if(values.dateFormatMonth){
        dateFormat+="M"
       }
       if(!dateFormat){
           values.seriesType=""
        }
        const payload = {
         ...values,
         dateFormat
        }
       CreateAxios({completeURL:`${process.env.REACT_APP_MASTER_API}/branchLrSeriesMapping?branchId=${values.branchId}`,payload}).then((res)=>{
        if(res?.data?.status===200){
            cogoToast.success(res?.data?.message, {position:"top-right"});
            setTimeout(()=>{
                window.location.reload()
            },1000)
        }else{
            cogoToast.error(res?.data?.message, {position:"top-right"})
        }
       }).catch((err)=>{
        console.log(err);
        cogoToast.error(err?.response?.data?.message, {position:"top-right"})
       })
    }

})(CreateLrSeries)
export default FormikCreateLrSeries
